import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { appRouteNames } from '../../app.routing.names';

import { SessionListRouteNames } from '../../modules/sessions/sessions.routing.names';
import {
  LiveSessionListRouteNames,
  LiveSessionListRouteParamIds,
} from '../../modules/live-session/live-session.routing.names';
import { errorRouteNames } from '../../modules/error/error.routing.names';

@Injectable({
  providedIn: 'root',
})
export class RouterService {
  private router = inject(Router);

  public navigateToSessionsList() {
    this.router.navigateByUrl(appRouteNames.SESSION_LIST);
  }

  public navigateToNewSession(sessionId: string) {
    this.router.navigate([
      appRouteNames.SESSION_LIST,
      this.insertParam(
        SessionListRouteNames.LIVE_SESSION,
        LiveSessionListRouteParamIds.SESSION_ID,
        sessionId,
      ),
    ]);
  }

  public navigateToRunningSession(sessionId: string, replaceURL: boolean = false): void {
    this.router.navigate(
      [
        appRouteNames.SESSION_LIST,
        this.insertParam(
          SessionListRouteNames.LIVE_SESSION,
          LiveSessionListRouteParamIds.SESSION_ID,
          sessionId,
        ),
        LiveSessionListRouteNames.RUNNING_SESSION,
      ],
      { replaceUrl: replaceURL },
    );
  }

  navigateToProfile() {
    this.router.navigateByUrl(appRouteNames.PROFILE);
  }

  navigateToParticipant(sessionId: string, participantId: string) {
    this.router.navigate([
      appRouteNames.SESSION_LIST,
      sessionId,
      LiveSessionListRouteNames.RUNNING_SESSION,
      participantId,
    ]);
  }

  navigateToMatchDetails(sessionId: string, participantId: string, matchId: string) {
    this.router.navigate([
      appRouteNames.SESSION_LIST,
      sessionId,
      LiveSessionListRouteNames.RUNNING_SESSION,
      participantId,
      matchId,
    ]);
  }

  navigateTo404() {
    this.router.navigate([appRouteNames.ERROR, errorRouteNames.ERROR404]);
  }

  navigateToLoadFailed() {
    this.router.navigate([appRouteNames.ERROR, errorRouteNames.LOAD_FAILED]);
  }

  private insertParam = (URL: string, paramName: string, replacement: string): string => {
    return URL.replace(':' + paramName, replacement);
  };
}
